module.exports = __webpack_public_path__ + "img/signal_wifi_3_bar_lock.a44547de.svg";